module.exports = __webpack_public_path__ + "static/img/btn6.51807a34.png";